__webpack_require__.p = "/wp-content/plugins/kam001-real-estate-blocks/dist/";